import Big from 'big.js'

/**
 * Multiplies two numbers using Big.js library to handle precision
 *
 * @param {number|string} first - First number to multiply
 * @param {number|string} second - Second number to multiply
 * @returns {number} Product of the two numbers, or 0 if invalid input or error occurs
 */
export function multiply (first, second) {
  try {
    let numA = Number(first)
    let numB = Number(second)

    if (isNaN(numA) || isNaN(numB)) return 0
    numA = Big(numA)
    numB = Big(numB)

    return Number(numA.times(numB).toString())
  } catch (e) {
    console.error(e)
    return 0
  }
}

/**
 * Divides two numbers using Big.js library to handle precision
 *
 * @param {number|string} dividend - First number (dividend)
 * @param {number|string} divisor - Second number (divisor)
 * @returns {number} Quotient of the two numbers, or 0 if invalid input or error occurs
 */
export function divide (dividend, divisor) {
  try {
    let numA = Number(dividend)
    let numB = Number(divisor)

    if (isNaN(numA) || isNaN(numB) || numB === 0) return 0
    numA = Big(numA)
    numB = Big(numB)

    return Number(numA.div(numB).toString())
  } catch (e) {
    console.error(e)
    return 0
  }
}
